import React, { useEffect, useState } from "react";
import { TableWork } from "../../../ui";
import Select from "../../../library/components/Select/index";
import BarcodeReader from "react-barcode-reader";
import Button from "../../../library/components/Button";
import {
  ALERT_TYPE_SUCCESS,
  ALERT_TYPE_ERROR,
  ALERT_TYPE_INFO,
} from "../../../constants/constants";
import { createAlert } from "../../../features/alert/alerts";
import InputField from "../../../library/components/InputField";
import { useDispatch } from "react-redux";
import {
  duplicate_plus,
  green_check,
  purple_excla,
  red_cross,
} from "../../../images";
import { TableLabel } from "./TableLabel";
import {
  useGetBallotPaperDataQuery,
  useScanBallotPaperMutation,
} from "../../../services/preCountingServices";
import ConfirmationModal from "../../../library/components/FileUpload/ConfirmationModal/ConfirmationModal";
import CustomModal from "../../../library/components/Modal/modal";
import "./index.css";
import { ScanballotHeader } from "../ScanballotHeader";
import PrecountingModal from "../PrecountingModal/PrecountingModal";
import LeftMenu from "../../AnalyticsModule/Left";

const ScanBallotPro = () => {
  const tableBody = [];
  const { data: userData, refetch } = useGetBallotPaperDataQuery();
  const dispatch = useDispatch();
  const [scanData, setScanData] = useState("");
  const [scanBallotPaper, datap] = useScanBallotPaperMutation();
  const [remove, setRemove] = useState(false);
  const [showConfirmationPopup, setConfirmationPopup] = useState(false);
  const [showConfirmationPopupManual, setConfirmationPopupManual] =
    useState(false);

  userData?.payload.map((item, i) => {
    tableBody.push({
      "S.No": item.slNoBallotPaper,
      Status:
        item.ballotPaperScanStatus === "V" ? (
          <TableLabel icon={green_check} color={"#24bc2a"} label={"Valid"} />
        ) : item.ballotPaperScanStatus === "I" ? (
          <TableLabel icon={red_cross} color={"#E30000"} label={item.message} />
        ) : item.ballotPaperScanStatus === "D" ? (
          <TableLabel
            icon={duplicate_plus}
            color={"#E66E00"}
            label={item.message}
          />
        ) : (
          item.ballotPaperScanStatus === "N" && (
            <TableLabel
              icon={purple_excla}
              color={"#8D00BE"}
              label={item.message}
            />
          )
        ),
    });
  });
  const initiPbid = {
    0: "",
    1: "",
    2: "",
    3: "",
  };
  const [PBID, setPBID] = useState({
    0: "",
    1: "",
    2: "",
    3: "",
  });
  const data = {
    head: ["S. No.", "Scanned"],
  };
  const handlePbid = (key, value) => {
    setPBID({ ...PBID, [key]: "" + value });
    if (value.length >= 4) {
      // Check if it's not the last input field
      if (key !== "4") {
        // Get the next input field
        const nextSibling = document.querySelector(
          `input[name=in-${Number(key) + 1}]`
        );
        // If found, focus the next field
        if (nextSibling !== null) {
          nextSibling.focus();
        }
      }
    } else if (value.length == 0) {
      if (key != 0) {
        // Get the prev input field
        const prevSibling = document.querySelector(
          `input[name=in-${Number(key) - 1}]`
        );
        // If found, focus the next field
        if (prevSibling !== null) {
          prevSibling.focus();
        }
      }
    }
  };
  const addEPBID = () => {
    let epbId = PBID[0] + PBID[1] + PBID[2] + PBID[3];
    if (epbId) {
      scanBallotPaper({
        epbId: epbId,
        isFirstTimeScan: "",
      })
        .unwrap()
        .then((res) => {
          if (res?.message?.includes("previously scanned")) {
            setConfirmationPopupManual(true);
          } else {
            if (res.statusCode == 200) {
              onSuccess(res?.message);
            }
          }
          refetch();
          window.scrollTo(0, 0);
        })
        .catch(() => {
          refetch();
        });
    } else {
      onInfo("Please Enter EPB-id");
    }
    // setPBID(initiPbid)
  };

  const handleScan = (data) => {
    setScanData("");
    setScanData(data);
  };
  const handleError = (err) => {};

  useEffect(() => {
    if (scanData !== "") {
      scanBallotPaper({
        epbId: scanData,
        isFirstTimeScan: "",
      })
        .unwrap()
        .then((res) => {
          if (res?.message?.includes("previously scanned")) {
            setConfirmationPopup(true);
          } else {
            onSuccess(res?.message);
            refetch();
            setScanData("")
          }
          window.scrollTo(0, 0);
        })
        .catch(() => {
          refetch();
        });
    }
  }, [scanData]);

  useEffect(() => {
    if (datap.isError) {
      //onReject(datap?.error?.data?.message)
    }
    if (datap.isSuccess && datap?.data?.message !== "Duplicate Scan") {
      // onSuccess(datap?.data?.message)
    }
    if (datap?.data?.message?.includes("previously scanned")) {
      // setConfirmationPopup(true)
      //setConfirmationPopupManual(true)
    }
  }, [datap.isError, datap.isSuccess]);

  const onSuccess = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_SUCCESS,
        heading: "Success",
      })
    );
  };

  const onReject = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_ERROR,
        heading: "Reject",
      })
    );
  };
  const onInfo = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_INFO,
        heading: "INFO",
      })
    );
  };
  const onClose = () => {
    setConfirmationPopup(false);
    setScanData("");
  };

  const reset = () => {
    scanBallotPaper({
      epbId: scanData,
      isFirstTimeScan: "No",
    }).then((res) => {
      if (String(res.message).includes("complete scan")) {
        onInfo(res.message);
      }
      setScanData("");
      refetch();
    });

    setRemove(false);
    setConfirmationPopup(false);
  };
  const resetManual = () => {
    let epbId = PBID[0] + PBID[1] + PBID[2] + PBID[3];
    scanBallotPaper({
      isFirstTimeScan: "No",
      epbId: epbId,
    })
      .unwrap()
      .then((res) => {
        if (String(res.message).includes("complete scan")) {
          onInfo(res.message);
        }
        refetch();
        setPBID(initiPbid);
      })
      .catch(() => {
        refetch();
        setPBID(initiPbid);
      });
    // setRemove(false);
    setConfirmationPopupManual(false);
  };

  return (
    <LeftMenu>
      {
        <CustomModal
          className="confirmation_modal"
          show={showConfirmationPopup}
          onClose={onClose}
          closeIcon={false}
          modalTitle={"Do you want to scan again ?"}
          children={
            <PrecountingModal
              noOption={reset}
              //size="500px"
              yesOption={() => {
                // setScanData("");
                setConfirmationPopup(false);
              }}
            />
          }
        />
      }
      {
        <CustomModal
          className="confirmation_modal"
          show={showConfirmationPopupManual}
          onClose={onClose}
          closeIcon={false}
          modalTitle={"Do you want to scan again ?"}
          children={
            <PrecountingModal
              noOption={resetManual}
              //size="500px"
              yesOption={() => {
                let epbId = PBID[0] + PBID[1] + PBID[2] + PBID[3];
                scanBallotPaper({
                  isFirstTimeScan: "Yes",
                  epbId: epbId,
                })
                  .unwrap()
                  .then((res) => {
                    if (String(res.message).includes("previously scanned")) {
                      onInfo(res.message);
                    }
                    setConfirmationPopupManual(false);
                  });
              }}
            />
          }
        />
      }
      <ScanballotHeader>
        <BarcodeReader onError={handleError} onScan={handleScan} />
        <div className="row container box fluid my-4 mx-1">
          <div
            className="row scanner-view col-md-4"
            style={{
              marginRight: "15px",
            }}
          >
            <div className="scanner"></div>
            {/* <Button value={'Confure qr scanner'} btnClass={'config-btn'} /> */}
          </div>
          <div className="form-default col-md-8">
            <div className="head-title mb-3">
              <div className="for_pbid mb-2"></div>
              <span className="mb-2">
                <strong className="mr-1">Enter e-PBID </strong>
                (Add e-PBID Manually in case QR Code is not scanned)
              </span>
              <div className="add-elector">
                {[0, 1, 2, 3].map((inputItem) => (
                  <InputField
                    name={"in-" + inputItem}
                    maxLength={4}
                    onChange={(value) => handlePbid(inputItem, value)}
                    inputClass="input-class"
                    value={PBID[inputItem]}
                    //inputClass="mr-2"
                  />
                ))}
                <Button
                  fa_icon="fa-plus plus-icon"
                  value="Add"
                  onClick={addEPBID}
                  btnClass="add-button"
                />
                <Button
                  value="Reset"
                  btnClass="reset-button"
                  onClick={() => setPBID(initiPbid)}
                />
              </div>
            </div>
            <TableWork
              id=""
              theadData={data.head}
              tbodyData={tableBody}
              anchorTagName=""
              anchorTagclassName="viewDetails"
              emptyMessage="No data found"
              pageSize={10}
              pagination={true}
              paginationClass={"text-right p-0"}
            />
          </div>
        </div>
      </ScanballotHeader>
    </LeftMenu>
  );
};
export default ScanBallotPro;
